<template>
    <div>
        <div class="row text-center">
            <div class="col-sm-6 text-left align-self-center">{{ userGroup.name }}</div>
            <div class="col-sm-6 d-flex justify-content-end align-self-center">
                <button class="ds-btn mr-1" @click="showModal(userGroup)" v-b-tooltip.hover.left.viewport title="Apskatīt/Rediģēt">
                    <font-awesome-icon icon="eye"/>
                </button>
                <button class="ds-btn ds-btn--danger" @click="handleUserGroupRemoval" v-b-tooltip.hover.right.viewport title="Dzēst">
                    <font-awesome-icon icon="trash"/>
                </button>
            </div>
        </div>
        <hr class="my-2"/>
    </div>
</template>
<script>
    import {mapActions, mapMutations} from 'vuex';

    import {UserGroup} from '../../vuex/modules/user/modules/user-groups/user-group.models';
    import * as userGroupStoreTypes from '../../vuex/modules/user/modules/user-groups/user-group.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'users-groups-list-item',
        props: {
            userGroup: {
                type: UserGroup,
                required: true,
            }
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('userGroup', {
                /** @type {function|*} */
                removeUserGroup: userGroupStoreTypes.ACTION_REMOVE_USER_GROUP,
                /** @type {function|*} */
                showModal: userGroupStoreTypes.ACTION_SHOW_MODAL,
            }),
            async handleUserGroupRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeUserGroup(this.userGroup._id);
                    this.setAlertData({type: 'primary', message: 'Darbinieka grupa izdzēsta!'});
                    // const users = await this.getUsers({companyId: this.$route.params.companyId});
                    // this.setCurrentCompanyUsers(users);
                } catch (err) {
                    //
                }
            },
        },
    }
</script>